export default class StringUtil {
    public static searchString(str: string, needle: string | RegExp): number {
        return str.search(needle);
    }
}
